module.exports = __webpack_public_path__ + "assets/images/HoldIcon.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/HoldIcon.png
// module id = 1383
// module chunks = 1